<script setup lang="ts">
defineProps({ blok: Object })
</script>

<template>
    <section class="section">
        <UiContainer>
            <header class="global-text">
                <StoryblokRichText :doc="blok?.header" />
            </header>
            <div>
                <div class="grid grid-cols-12 gap-6 max-[641px]:gap-x-0 max-[641px]:gap-y-12">
                    <div
                        v-for="item in blok?.partners"
                        :key="item._uid"
                        class="col-span-3 max-[769px]:col-span-6 max-[641px]:col-span-12 "
                    >
                        <TeamItem
                            :image="item.logo"
                            :name="item.name"
                            :link="item.url"
                        />
                    </div>
                </div>
            </div>
        </UiContainer>
    </section>
</template>
